<div *ngIf="expander; else elseBlock" class="collapse-icon">
  <div class="collapse-default">
    <div class="card">
      <div class="card-header">
        <div class="row collapse-title btn pl-0 pr-0 pt-0 pb-0"
             (click)="isCollapsed1 = !isCollapsed1"
             [attr.aria-expanded]="!isCollapsed1"
             aria-controls="collapseExample"
             data-toggle="collapse"
             role="button">
          <div class="big-circle">
            <img class="img-expander" src="assets/images/wallet.svg" alt="">
          </div>
          <div class="right-content">
            <div class="small-text text-left">{{smallText | translate}}</div>
            <div *ngIf="!showLinkInsteadFlag" class="big-text">{{bigText}}</div>
            <div *ngIf="showLinkInsteadFlag" class="medium-text ">
              <button class="btn btn-primary" (click)="goToHistory()">
                {{ 'AVAILABLE_BUDGET.PENDING_PAYMENT' | translate }}<span class="d-block">{{bigText}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div [ngbCollapse]="isCollapsed1" id="collapseExample">
        <div class="card">
          <div class="card-body">
            <div class="row" [ngClass]="{'compact': isCompact}">
              <div [class.col-4]="!isCompact" [class.col-12]="isCompact">
                <div class="icon-text-container">
                  <i class="bi bi-box"></i>
                  <div class="text-inner-budget">{{ 'BUDGET.STANDARD_SHORT' | translate }}</div>
                </div>
              </div>
              <div class="font-bold" [class.col-8]="!isCompact" [class.col-12]="isCompact">{{this.standardBudget?.toFixed(2)}} {{'DASHBOARD.UNIT' | translate}}</div>
            </div>
            <div  *ngIf="hasTransportBudget" class="row mt-1" [ngClass]="{'compact': isCompact}">
              <div [class.col-4]="!isCompact" [class.col-12]="isCompact">
                <div class="icon-text-container">
                  <i class="bi bi-fuel-pump"></i>
                  <div class="text-inner-budget">{{ 'BUDGET.TRANSPORT_SHORT' | translate }}</div>
                </div>
              </div>
              <div class="font-bold" [class.col-8]="!isCompact" [class.col-12]="isCompact">{{transportBudget?.toFixed(2)}} {{'DASHBOARD.UNIT' | translate}}</div>
            </div>
            <div *ngIf="hasProfessionalDevelopmentBudget" class="row mt-1" [ngClass]="{'compact': isCompact}">
              <div [class.col-4]="!isCompact" [class.col-12]="isCompact" >
                <div class="icon-text-container">
                  <i class="bi bi-display"></i>
                  <div class="text-inner-budget">{{ 'BUDGET.PROFESSIONAL_DEVELOPMENT_SHORT' | translate }}</div>
                </div>
              </div>
              <div class="font-bold" [class.col-8]="!isCompact" [class.col-12]="isCompact">{{professionalDevelopmentBudget?.toFixed(2)}} {{'DASHBOARD.UNIT' | translate}}</div>
            </div>
            <div *ngIf="cashbackBudget" class="row mt-1" [ngClass]="{'compact': isCompact}">
              <div [class.col-4]="!isCompact" [class.col-12]="isCompact" >
                <div class="icon-text-container">
                  <i class="bi bi-cash"></i>
                  <div class="text-inner-budget">{{ 'BUDGET.CASHBACK' | translate }}</div>
                </div>
              </div>
              <div class="font-bold" [class.col-8]="!isCompact" [class.col-12]="isCompact">
                {{cashbackBudget?.toFixed(2)}} {{'DASHBOARD.UNIT' | translate}}
                {{'(' + cashbackPendingAmount.toFixed(2)}} {{'DASHBOARD.UNIT' | translate}}
                <br>
                {{'BUDGET.PENDING_CASHBACK' | translate}}{{')'}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #elseBlock>
    <div class="row budget-content">
        <div class="big-circle">
          <img src="assets/images/wallet.svg" alt="">
        </div>
        <div class="right-content">
            <div class="small-text text-left">{{ smallText | translate}}</div>
            <div *ngIf="!showLinkInsteadFlag" class="big-text">{{bigText}}</div>
            <div *ngIf="showLinkInsteadFlag" class="medium-text ">
                <button class="btn btn-primary" (click)="goToHistory()">
                    {{ 'AVAILABLE_BUDGET.PENDING_PAYMENT' | translate }}<span class="d-block">{{bigText}}</span>
                </button>
            </div>
        </div>
    </div>
</ng-template>
